import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import toJS from '../general/toJS'
import PagePreviewMoviesPage from '../../components/PagePreviewMovies/present/PagePreviewMoviesPage'
import { previewMoviesDeleteRequest, previewMoviesCreateRequest, previewMoviesUpdateItem } from '../../actions'
import getData from '../../functions/getData'
import {
    PREVIEW_MOVIES_ITEMS,
    PROGRAM_CLI_MOVIES_ITEMS,
    PROGRAM_CINEMAS,
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_TMDB_MOVIES_ITEMS,
    PROGRAM_PY_MOVIES_ITEMS,
    PROGRAM_KH_MOVIES_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
    PROGRAM_MARSX_MOVIES_ITEMS,
    PROGRAM_VISTA_MOVIES_ITEMS,
    CLI_CINEMA_CLIENT_ID,
} from '../../constants/state'
import actionTypes from '../../actions/actionTypes'

const mapStateToProps = state => ({
    items:          getData(state, PREVIEW_MOVIES_ITEMS),
    cliMovies:      getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    timezone:       state.getIn(['translation', 'timezone']),
    cinemas:        getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    movieMappings:  getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    tmdbMovies:     getData(state, PROGRAM_TMDB_MOVIES_ITEMS),
    pyMovies:       getData(state, PROGRAM_PY_MOVIES_ITEMS),
    khMovies:       getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compesoMovies:  getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    dieselMovies:   getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    cortecMovies:   getData(state, PROGRAM_CORTEC_MOVIES_ITEMS),
    marsxMovies:    getData(state, PROGRAM_MARSX_MOVIES_ITEMS),
    vistaMovies:    getData(state, PROGRAM_VISTA_MOVIES_ITEMS),
})

const mapDispatchToProps = dispatch => ({
    onDelete:     (pk) => dispatch(previewMoviesDeleteRequest(pk)),
    onEdit:       (pk, data) => dispatch(previewMoviesUpdateItem(pk, data)),
    onCreateEdit: (data) => dispatch(previewMoviesCreateRequest({ ...data, redirectTo: 'edit' })),
    onCreateTmdb: (data) => dispatch(previewMoviesCreateRequest({ ...data, redirectTo: 'tmdb' })),
    onMerge: (sourceMetaMoviePk, destinationMetaMoviePk) => dispatch({
        type: actionTypes.META_MERGE_REQUEST,
        payload: { sourceMetaMoviePk, destinationMetaMoviePk },
    }),
})

const PagePreviewMoviesContainer = props => <PagePreviewMoviesPage {...props} />

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PagePreviewMoviesContainer))
